// src/pages/Settings.js
import React from 'react';

const Settings = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-2">Settings</h2>
      <p>This is the Settings page. You can customize your preferences here.</p>
    </div>
  );
};

export default Settings;